import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

import { OccurrenceService } from '../../../core/services/occurrence/occurrences/occurrences.service'
import { OccurrenceOsService } from '../../../core/services/occurrence/occurrences-os/occurrences-os.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { NOME_FASE } from '../../../core/models/monitoring-os.model'

// Registro de ocorrência da Torre — catálogo fixo por fase (originalmente 20
// modelos, 5 por fase, quando o farol tinha 4 fases; não confirmado se o back
// já tem modelos pra fase 1 nova "Motorista notificado" da leva 5). Ao criar,
// manda ocorrenciaId e NÃO manda tipoOcorrenciaId: a categoria
// é propriedade do modelo e o back a deriva (inverso do modal antigo de
// ocorrência, que ainda pede tipoOcorrenciaId). Modal novo em vez de reformar o
// occurrences-modal-create compartilhado: aquele tem um segundo consumidor
// (pages/occurrence/occurrences) que hoje o abre sem nenhum `data`.
@Component({
  selector: 'modal-ocorrencia-fase',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinner,
  ],
  templateUrl: './modal-ocorrencia-fase.component.html',
  styleUrl: './modal-ocorrencia-fase.component.scss',
})
export class ModalOcorrenciaFaseComponent implements OnInit {
  @Output() response = new EventEmitter<boolean>()

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { codigoOs: string; codigoTg: string; fase?: number },
    private dialogRef: MatDialogRef<ModalOcorrenciaFaseComponent>,
    private occurrenceService: OccurrenceService,
    private occurrenceOsService: OccurrenceOsService,
    private snackbar: SnackbarCustomService,
  ) {}

  form!: FormGroup
  // 5 fases desde a leva 5 (entrou "Motorista notificado" como fase 1).
  fases = [1, 2, 3, 4, 5]
  nomeFase = NOME_FASE
  catalogo: any[] = []
  loadingCatalogo = false
  saving = false

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      fase: [this.data.fase ?? null, [Validators.required]],
      ocorrenciaId: [null, [Validators.required]],
      observacao: ['', [Validators.required]],
      dataOcorrido: [null, [Validators.required]],
      horaOcorrido: [''],
    })

    if (this.data.fase) this.loadCatalogo(this.data.fase)

    this.form.get('fase')!.valueChanges.subscribe((fase: number) => {
      this.form.get('ocorrenciaId')!.setValue(null)
      if (fase) this.loadCatalogo(fase)
    })
  }

  loadCatalogo(fase: number): void {
    this.loadingCatalogo = true
    this.occurrenceService.listOccurrenceByFase(fase, true).subscribe({
      next: (res: any) => { this.catalogo = res.data ?? [] },
      error: (err: any) => { this.snackbar.errorRequest(err) },
      complete: () => { this.loadingCatalogo = false },
    })
  }

  registrar(): void {
    if (this.form.invalid) return
    this.saving = true
    const v = this.form.value
    const model = {
      ordemServicoId: this.data.codigoOs,
      ocorrenciaId: v.ocorrenciaId,
      observacao: v.observacao,
      dataOcorrido: this.formatDate(v.dataOcorrido),
      horaOcorrido: v.horaOcorrido || undefined,
    }
    this.occurrenceOsService.createOccurrenceServiceOrder(model).subscribe({
      next: (res: any) => {
        this.saving = false
        this.snackbar.success(res.message ?? 'Ocorrência registrada com sucesso.')
        this.response.emit(true)
        this.dialogRef.close()
      },
      error: (err: any) => {
        this.saving = false
        this.snackbar.errorRequest(err)
      },
    })
  }

  private formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    return `${day}/${month}/${date.getFullYear()}`
  }

  close(): void {
    this.dialogRef.close()
  }
}
